import { createContext } from "react";  
import { UserStateType } from "./type/state.type";


export const UserContext = createContext<UserStateType>({} as UserStateType)